import type { ReactNode } from "react";
import { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router";
import logoGeneric from "@/assets/logos/generic.svg";
import SearchBar from "@/components/input/search-bar.input.jsx";
import GlobalSidebarMenu from "@/components/layout/sidebar/global-sidebar-menu.jsx";

interface GlobalSidebarProps {
  children?: ReactNode;
  isDrawerOpen?: boolean;
  isTestMode?: boolean;
  onDrawerClose?: () => void;
}

export default function GlobalSidebar({
  children,
  isDrawerOpen = false,
  isTestMode = false,
  onDrawerClose = () => {},
}: GlobalSidebarProps) {
  const [searchValue, setSearchValue] = useState("");
  const drawerInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (drawerInputRef.current) {
      drawerInputRef.current.checked = isDrawerOpen;
    }
  }, [isDrawerOpen]);

  const logoInner = (
    <>
      <div className={!isTestMode ? "w-10 h-10 sj-logo bg-base-content" : "hidden"} />
      <img
        alt="Play Live Tools Logo"
        src={`${logoGeneric}`}
        className={isTestMode ? "w-8 fill-base-content opacity-90 " : "hidden"}
      />
      <span className={!isTestMode ? "" : "hidden"}>St. Jude</span>
      <span className="text-gray-500">Play Live Tools</span>
    </>
  );

  return (
    <div className="drawer lg:drawer-open overflow-hidden h-full">
      <input ref={drawerInputRef} id="global-drawer" type="checkbox" className="drawer-toggle" />

      <div className="drawer-content overflow-hidden flex flex-col items-center justify-center">
        {children}
      </div>
      <div className="drawer-side top-16 h-full">
        <label
          onKeyPress={() => onDrawerClose()}
          htmlFor="global-drawer"
          aria-label="close sidebar"
          className="drawer-overlay"
          onClick={() => {
            onDrawerClose();
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              onDrawerClose();
            }
          }}
        />
        <aside className="bg-base-300 w-full md:w-auto h-[calc(100%-4rem)]  md:h-full overflow-y-auto overflow-x-hidden flex flex-col">
          <NavLink
            className="lg:btn-ghost m-1 ml-2 mt-2 no-animation text-xl hidden lg:inline-flex lg:btn py-8"
            to="/"
          >
            {logoInner}
          </NavLink>
          <div className="mt-4 mx-3 bg-base-300">
            <SearchBar onSearch={setSearchValue} />
          </div>
          <div className="grow pr-2">
            <GlobalSidebarMenu onLinkClick={() => onDrawerClose()} searchValue={searchValue} />
          </div>
        </aside>
      </div>
    </div>
  );
}
